import React from 'react';
import { Link } from 'react-router-dom';
import '../style/Recommendations.css';

const Recommendations = () => {
  return (
    <div className="recommendations-container">
      <div className="page-header">
        <h1 className="page-title">Recommendations</h1>
      </div>
      <div>
        <div className="recommendations-landing">
          <header className="recommendations-header">
            <p className="recommendations-intro">
              Get personalized cat food recommendations based on your cat's
              specific needs from our database of 2,000+ products.
            </p>
            <p className="recommendations-section-title">Choose how you'd like to get recommendations:</p>
          </header>

          <div className="recommendations-options">
            <section className="recommendations-option-card">
              <h2>Quick Quiz</h2>
              <div className="recommendations-divider" />
              <p>
                Answer a few specific questions about your cat's age, specific needs, and preferences. We'll use your answers to filter our database 
                and show you the best matches.
              </p>
              <p className="recommendations-option-note">⏱ Takes 2 minutes</p>
              <Link className="recommendations-option-button" to="/Quiz">
                Start quiz
              </Link>
            </section>

            <section className="recommendations-option-card recommendations-option-card--chat recommendations-option-card--wip">
              <div className="recommendations-card-header">
                <h2>Chat with The Picky Kitty</h2>
                <span className="recommendations-wip-badge">Coming soon</span>
              </div>
              <div className="recommendations-divider" />
              <div className="recommendations-chat-row">
                <p className="recommendations-option-text">
                  Describe your cat's needs in your own words. The Picky Kitty will ask follow-up questions and help you find the perfect food.
                </p>
                <div className="recommendations-chat-image">
                  <img
                    src="/picky-kitty/profile_pic.PNG"
                    alt="The Picky Kitty"
                  />
                </div>
              </div>
              <p className="recommendations-option-note">💬 Interactive and conversational</p>
              <span className="recommendations-option-button recommendations-option-button--disabled">
                Start chat
              </span>
            </section>
          </div>

          <div className="recommendations-footer">
            <Link className="recommendations-browse-link" to="/Database">
              Or browse the full database →
            </Link>
            <p className="recommendations-disclaimer">
              Recommendations are based solely on user-provided preferences; we do not rate or endorse product quality.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Recommendations;